import { ApiClientError } from '@raydiant/api-client-js';
import raydiant from '../clients/raydiant';
import useProtectedMutation from './useProtectedMutation';

export default function useDeleteDevicePaymentTerminal() {
  const mutation = useProtectedMutation<string, ApiClientError, string>(
    (deviceId) => raydiant.deleteDeviceTerminal(deviceId),
  );

  return mutation;
}
